import { render } from "./DefaultLinkDropDownMenuItem.vue?vue&type=template&id=2b9e01df"
import script from "./DefaultLinkDropDownMenuItem.vue?vue&type=script&lang=js"
export * from "./DefaultLinkDropDownMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__